import { useState } from 'react'

export const useDishTechComponentsState = <T>({ defaultItems }: { defaultItems: Array<T> }) => {
  const [state, setState] = useState<Array<T>>()

  const updateState = (updateFn: (items: Array<T>) => Array<T>) => {
    setState((prev) => updateFn(prev || defaultItems))
  }

  return {
    dishTechItems: state || defaultItems,
    updateDishTechItems: updateState,
  }
}
